import { type V4Theme, v4 } from '@packages/themes/v4';
import { createMakeStyles } from 'tss-react';

const { makeStyles } = createMakeStyles<V4Theme>({
  useTheme: () => v4,
});

export { makeStyles };
